<div mat-dialog-title class="title_label_height">
    <h2 class="logout_Css">{{'confirmLogout' | localize}}</h2>
    <!-- <button mat-button [mat-dialog-close]="true" class="close_btn">X</button> -->
</div>
<hr>
<div mat-dialog-content  class="content_css">
    <h1 class="label_Text">{{'no Agent Available' | localize}}</h1>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button id="closeButton" class="green_bg" (click)="onDialogCancel()">{{'stayLoggedIn' | localize }}</button>
    <button mat-raised-button id="closeButton" class="reset_bg" (click)="confirmToLogout()">{{'confirmToLogout' | localize }}</button>
</div>
